import styled from 'styled-components'
import { Card, Link } from 'components'

const Prompt = styled(Card)`
  ${({ theme: { colors } }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1.5rem;
  text-align: center;
  color: ${colors('text')};
  `}
`

// Usernames are how chat participants find/address each other (roshambo
// targeting, direct messages) — block entry until one is set rather than
// letting someone chat under a name nobody can reference.
export const RequireUsername = ({ user, children }) => {
  if (user?.username) return children

  return (
    <Prompt>
      <div>Set a username before you can use chat.</div>
      <Link to="/account">go to account</Link>
    </Prompt>
  )
}
